<template>
  <main :id="$style.main">
    <main-title
      :class="$style.main_title"
      :main_title="'松井秀喜の言葉'"
      :sub_title="'〜 Saying 〜'"
      :color="'#403f3f'"
      :align="'center'"
    ></main-title>
    <div :id="$style.saying_view">
      <saying-list-visual @child_event="handleClick"></saying-list-visual>
      <saying-screen-visual :item="item"></saying-screen-visual>
      <!-- <saying-modal-visual :item="item" :modal="modal"></saying-modal-visual> -->
    </div>
  </main>
</template>

<script lang="ts">
import Vue from "vue";
import MainTitle from "@/components/atoms/MainTitle.vue";
import SayingScreenVisual from "@/components/organsms/saying/SayingScreenVisual.vue";
import SayingListVisual from "@/components/organsms/saying/SayingListVisual.vue";
//import SayingModalVisual from "@/components/organsms/saying/SayingModalVisual.vue";

export default Vue.extend({
  name: "SayingView",
  components: {
    MainTitle,
    SayingScreenVisual,
    SayingListVisual,
    //SayingModalVisual,
  },
  data() {
    return {
      item: {},
      //modal: false,
    };
  },
  methods: {
    handleClick(item) {
      this.item = item;
      //this.modal = modal;
    },
  },
});
</script>

<style lang="scss" module>
@import "../../assets/style/base.scss";

@media only screen and (max-width: 1023px) {
  #main {
    // background: #dfdfe0;
    background: #f8f2dd;
    display: block;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    #saying_view {
      justify-content: center;
      display: block;
    }
    .main_title {
      margin-bottom: 10px;
      align-items: center;
    }
  }
}
@media only screen and (min-width: 1024px) {
  #main {
    // background: #dfdfe0;
    background: #f8f2dd;
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-wrap: wrap;
    //typo修正する
    #saying_view {
      justify-content: center;
      display: flex;
    }
    .main_title {
      margin-bottom: 30px;
      margin-right: 250px;
      align-items: center;
    }
  }
}
</style>
